import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/action-module-navigation.module.css";
import { ActionLinks, ColorScheme } from "../types/index.js";
import { css } from "../utils/emotion.js";
import {
  getEnquiryBookingLinks,
  getVouchersSpecialsLinks,
} from "../utils/utils.js";
import Button from "./Button.js";
import Icon from "./Icon.js";
import SmartLink from "./SmartLink.js";

interface Props {
  scheme: ColorScheme | undefined;
  isPreview: boolean;
  actionLinks: ActionLinks;
  className?: string;
  itemClassName?: string;
  onItemClick?: () => void;
  showQuickLinks: boolean;
}

const ActionModuleNavigation: FunctionComponent<Props> = ({
  scheme,
  isPreview,
  actionLinks,
  className,
  itemClassName,
  onItemClick,
  showQuickLinks,
}) => {
  const bookingEnquiry = getEnquiryBookingLinks(actionLinks);
  const vouchersSpecials = getVouchersSpecialsLinks(actionLinks);

  return (
    <div className={ClassNames(styles.ActionModuleNavigation, className)}>
      {showQuickLinks && (
        <div className={styles.ActionModuleNavigation__Quick}>
          {vouchersSpecials.map(({ label, href, type }) => (
            <SmartLink
              key={type}
              anchorAttrs={{
                className: styles.ActionModuleNavigation__QuickItem,
                href,
                title: label,
              }}
              isPreview={isPreview}
            >
              <Icon
                className={ClassNames(
                  styles.ActionModuleNavigation__Icon,
                  css({ fill: scheme?.primary.background }),
                )}
                glyph={type}
              />
            </SmartLink>
          ))}
        </div>
      )}

      {bookingEnquiry.map(({ label, href, type }, index) => (
        <Button
          className={ClassNames(
            styles.ActionModuleNavigation__Item,
            itemClassName,
          )}
          key={index}
          type={type === "enquiry" ? "secondary" : "primary"}
          anchorAttrs={{ href, onClick: onItemClick }}
          scheme={scheme}
          isPreview={isPreview}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default ActionModuleNavigation;
